<template>
    <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3950_77416)">
            <path
                d="M2 29C2 13.536 14.536 1 30 1C45.464 1 58 13.536 58 29C58 44.464 45.464 57 30 57C14.536 57 2 44.464 2 29Z"
                fill="url(#paint0_linear_3950_77416)"
            />
            <path
                d="M38.467 22.3989C38.467 22.1943 38.0584 22.3194 37.8314 22.2569C37.6043 22.1943 37.5249 22.1318 37.5249 22.1318C37.5249 22.1318 37.5192 22.4444 37.3433 22.5808C37.1617 22.7229 37.0425 22.7229 37.0425 22.7229C37.0425 22.7229 37.0368 22.99 37.7746 24.0072C38.5124 25.0245 39.1821 25.1268 39.1821 24.9222C39.1821 24.7176 38.7054 23.9959 38.5748 23.3537C38.4954 22.99 38.467 22.6035 38.467 22.3989Z"
                fill="white"
            />
            <path
                d="M39.596 34.0552C37.1783 30.5089 32.4904 28.6335 31.4575 24.6099C30.5664 21.1546 32.4393 19.9043 33.4893 19.9668C34.5903 20.035 35.0727 21.0637 35.7538 21.6718C36.4405 22.2855 36.7129 22.0866 36.8491 21.7229C36.991 21.3365 36.5313 20.7909 36.2021 20.4329C35.7481 19.9441 36.2986 19.8361 36.7072 20.143C37.394 20.6659 37.184 21.4047 37.6096 21.649C38.1658 21.973 38.8809 21.1887 38.5915 20.1032C38.2964 19.0178 37.1783 17.0344 33.8866 17.0003C30.5948 16.9662 28.79 20.0578 28.79 23.0868C28.79 26.1216 30.5494 28.3096 31.991 29.9008C33.4382 31.4921 35.4984 33.4812 36.9172 35.152C39.8117 38.5562 38.075 40.9885 38.075 40.9885C38.075 40.9885 42.8934 38.8858 39.596 34.0552Z"
                fill="white"
            />
            <path
                d="M31.2135 31.3389C29.3803 29.5316 28.5914 28.5257 28.0807 27.3664C27.8593 26.9799 27.3996 25.4171 27.2066 26.8265C27.0137 28.2359 27.4166 29.3953 27.7345 30.0829C27.8536 30.3386 27.6664 30.3841 27.4847 30.2648C27.0477 29.9692 26.2532 28.7133 26.0659 28.2757C25.9297 27.9631 25.7197 28.2814 25.6743 28.8724C25.6062 29.7362 25.8502 30.708 26.361 31.4184C26.4859 31.5889 26.3667 31.7139 26.0886 31.623C22.7855 30.5944 21.2475 29.2077 19.681 27.6051C19.4767 27.3948 19.3973 27.6505 19.4313 28.1052C19.4654 28.611 19.5846 29.2873 19.9137 29.9692C20.4075 30.8728 20.7878 31.5264 21.361 31.964C21.605 32.1515 21.3837 32.2311 21.0148 32.1515C20.5778 32.0606 19.9421 31.731 19.2838 31.2991C19.1419 31.2082 19 31.2536 19 31.373C19 31.4582 19.017 31.5719 19.0511 31.7083C19.1192 31.9754 19.2724 32.2879 19.4881 32.6176C20.2543 33.6917 21.185 34.3964 21.9172 34.8453C22.1782 35.0044 21.9682 35.1067 21.588 35.067C21.2304 35.0272 20.7197 34.851 20.1748 34.5953C19.9308 34.5384 19.9308 34.7601 20.0954 35.0897C20.277 35.4477 21.1737 37.0958 24.2781 38.4825C24.5846 38.6189 24.9081 38.8632 24.0681 38.9428C23.5063 38.994 22.7231 38.9201 21.7696 38.5109C21.6674 38.4768 21.4291 38.5677 21.5653 38.778C22.5358 40.2954 25.084 40.9489 25.4586 41.0001H37.5132C37.5132 41.0001 38.4326 38.9599 36.2135 36.1695C34.9422 34.5839 32.638 32.7426 31.2135 31.3389Z"
                fill="white"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_3950_77416"
                x="0"
                y="0"
                width="60"
                height="60"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_3950_77416"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_3950_77416"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_3950_77416"
                x1="2.03424"
                y1="57.0605"
                x2="58.0342"
                y2="56.992"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#1D2027" />
                <stop offset="0.502215" stop-color="#2E3441" />
                <stop offset="1" stop-color="#1D2027" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: "SwanDarkIcon",
};
</script>
